import { render, staticRenderFns } from "./Addpayroute.vue?vue&type=template&id=ec59d5b6&scoped=true"
import script from "./Addpayroute.vue?vue&type=script&lang=js"
export * from "./Addpayroute.vue?vue&type=script&lang=js"
import style0 from "./Addpayroute.vue?vue&type=style&index=0&id=ec59d5b6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec59d5b6",
  null
  
)

export default component.exports